import React, { Component } from 'react';
import { Form } from 'react-final-form';

import TextField from '../../../components/Form/TextField';
import EmailField from '../../../components/Form/EmailField';
import SelectArrayField from '../../../components/Field/NewSelectArrayField';
import { isEmail, isInteger, isRequired } from '../../../utils/validation';
import { updateUser } from '../../../api/users';
import { roleChoices } from '../../../utils/constants';

class Edit extends Component {
  state = {
    loading: true,
    error: null,
    user: null,
  };

  handleSubmit = async (data) => {
    const { id, checkRole } = this.props;
    this.setState({ loading: true });
    try {
      await updateUser(id, data);
      checkRole(data);
      this.setState({ user: data });
    } catch (e) {
      const error = typeof e.request !== 'undefined'
        ? JSON.parse(e.request.response)
        : e.getMessage;
      this.setState({ error });
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { error } = this.state;
    const { user } = this.props;
    return (
      <Form
        onSubmit={this.handleSubmit}
        initialValues={user}
        render={({ handleSubmit, submitting, pristine }) => (
          <>
            <div className="columns">
              <div className="column is-half">
                <TextField
                  errors={
                    error
                    && typeof error.nome !== 'undefined'
                    && error.nome
                  }
                  name="nome"
                  placeholder="es. Mario Rossi"
                  validate={isRequired}
                  label="Nome"
                />
              </div>
              <div className="column is-half">
                <TextField
                  errors={
                    error
                    && typeof error.username !== 'undefined'
                    && error.username
                  }
                  name="username"
                  placeholder="es. m.rossi"
                  validate={isRequired}
                  label="Username"
                />
              </div>
            </div>
            <div className="columns">
              <div className="column is-half">
                <EmailField
                  errors={
                    error
                    && typeof error.email !== 'undefined'
                    && error.email
                  }
                  name="email"
                  placeholder="es. john@foo.com"
                  validate={isEmail}
                  label="Indirizzo e-mail"
                />
              </div>
              <div className="column is-half">
                <TextField
                  disabled
                  name="oldId"
                  placeholder="es. 123"
                  validate={isInteger}
                  label="Old Id"
                />
              </div>
            </div>
            <div className="columns">
              <div className="column is-half">
                <SelectArrayField
                  isMulti
                  name="ruoli"
                  placeholder="Ruoli"
                  label="Ruoli"
                  options={roleChoices}
                  value={user?.ruoli}
                />
              </div>
            </div>
            <footer>
              <div className="field">
                <div className="control">
                  <button
                    type="submit"
                    onClick={handleSubmit}
                    className="button is-orange is-large"
                    disabled={submitting || pristine}
                  >
                    Modifica
                  </button>
                </div>
              </div>
            </footer>
          </>
        )}
      />
    );
  }
}

export default Edit;
